import { z } from "zod";
export const teamsTenantIdSchema = z.string().trim().min(1).max(128);
export const claimTeamsTenantLinkInputSchema = z.object({
    teamsTenantId: teamsTenantIdSchema,
});
export const teamsTenantLinkSchema = z.object({
    teamsTenantId: teamsTenantIdSchema,
    tenantSlug: z.string().trim().min(1),
    organisationId: z.string().trim().min(1),
    organisationName: z.string().trim().min(1),
    runnerUserId: z.string().trim().min(1),
    createdAt: z.number(),
});
export const teamsTenantLinkResponseSchema = z.object({
    link: teamsTenantLinkSchema,
});
export const claimTeamsTenantLinkResponseSchema = z.object({
    link: teamsTenantLinkSchema,
    alreadyLinked: z.boolean(),
});
export const createTeamsTaskInputSchema = z.object({
    teamsTenantId: teamsTenantIdSchema,
    externalUserId: z.string().trim().min(1).max(256).optional(),
    externalUserName: z.string().trim().min(1).max(256).optional(),
    conversationId: z.string().trim().min(1).max(256),
    activityId: z.string().trim().min(1).max(256),
    threadId: z.string().trim().min(1).max(1024),
    serviceUrl: z.string().trim().min(1).max(1024).optional(),
    replyToId: z.string().trim().min(1).max(256).optional(),
    scope: z.string().trim().min(1).max(32).optional(),
    prompt: z.string().trim().min(1),
});
export const createTeamsTaskResponseSchema = z.object({
    taskId: z.string().trim().min(1),
    runId: z.string().trim().min(1),
    sessionId: z.string().trim().min(1).optional(),
    // True when this Teams activity already created a task (Bot Framework
    // redelivers); callers get the original ids back.
    deduped: z.boolean(),
});
